import { Injectable } from '@angular/core';
import { CacheStorage, QueryBus, Wrapper } from '@skylab-angular-shared/core';
import { CacheableQuickListDataSourceBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@Wrapper(CacheableQuickListDataSourceBase)
export class CacheableQuickListDataSource {
    public constructor(
        queryBus: QueryBus,
        cacheStorage: CacheStorage,
    ) { }
}
